export const TabDocumentos = () => {
  return <div>Conteúdo da aba Documentos</div>;
};
